export default __webpack_public_path__ + "static/media/logo.d9a8d166.svg";